var React = require('react');

function Dial0 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0.0705092L0 500C0 776.108 223.892 1000 500 1000C776.178 1000 1000 776.108 1000 500C1000 223.892 776.108 -1.3668e-05 500 -1.3668e-05L0 0.0705092Z","fill":"currentColor"}));
}

Dial0.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Dial0;

Dial0.default = Dial0;
